const TAB_ID = crypto.randomUUID();
const CHANNEL_NAME = "app-multi-tab";

const channel =
  "BroadcastChannel" in globalThis ? new BroadcastChannel(CHANNEL_NAME) : null;

export function useMultiTabBroadcast() {
  const isFromSelf = (data) => data.tabId === TAB_ID;

  const broadcast = (type, data = {}) => {
    channel?.postMessage({ type, tabId: TAB_ID, ...data });
  };

  const sendAck = (eventId) => {
    channel?.postMessage({ type: "ack", tabId: TAB_ID, eventId });
  };

  const broadcastAndWaitForAcks = (type, data = {}, timeout = 2000) => {
    return new Promise((resolve) => {
      if (!channel) {
        resolve();
        return;
      }

      const eventId = crypto.randomUUID();

      const timeoutId = setTimeout(() => {
        channel.removeEventListener("message", onMessage);
        resolve();
      }, timeout);

      const onMessage = (event) => {
        if (event.data?.type === "ack" && event.data?.eventId === eventId) {
          clearTimeout(timeoutId);
          channel.removeEventListener("message", onMessage);
          resolve();
        }
      };

      channel.addEventListener("message", onMessage);
      channel.postMessage({ type, tabId: TAB_ID, eventId, ...data });
    });
  };

  const onMessage = (callback) => {
    if (!channel) return () => {};
    const handler = (event) => callback(event.data);
    channel.addEventListener("message", handler);
    return () => channel.removeEventListener("message", handler);
  };

  return { isFromSelf, broadcast, sendAck, broadcastAndWaitForAcks, onMessage };
}
